import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import amplitude from 'amplitude-js';
import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import smartlookClient from 'smartlook-client';
import { updateLoggedUser } from '../actions/api';
import Icon from '../components/Icon';
import * as types from '../constants/ActionTypes';
import ApiV2ModelContext from '../contexts/ApiV2ModelContext';
export class OnboardForm extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            email: '',
            storing: false,
        };
        this.handleChangeEmail = (event) => {
            this.setState({
                email: event.target.value,
            });
        };
        this.handleOnboard = async (event) => {
            const { dispatch } = this.props;
            event.preventDefault();
            if (this.state.email && this.emailRef && this.emailRef.validity.valid) {
                this.setState({ storing: true });
                const repositories = await this.context.getRepositoryList(true);
                if (repositories.length) {
                    dispatch({ type: types.CLEAR_REPOSITORIES });
                    dispatch({
                        type: types.BULK_RELOAD_REPOSITORIES,
                        payload: repositories,
                    });
                }
                dispatch(updateLoggedUser({ email: this.state.email })).then((action) => {
                    if (action.type === types.UPDATE_LOGIN_USER_DETAILS_SUCCESS) {
                        dispatch({
                            type: types.LOGGED_USER,
                            payload: action.response.data,
                        });
                        this.setState({ storing: false });
                        const eventName = 'email-inserted';
                        amplitude.getInstance().logEvent(eventName);
                        smartlookClient.track(eventName, {});
                    }
                    else {
                        console.error(action);
                    }
                });
            }
        };
    }
    render() {
        const { browser, t } = this.props;
        const { email } = this.state;
        return (_jsx("form", { className: "onboard-form", onSubmit: this.handleOnboard, children: _jsxs("div", { className: "onboard-form__message", children: [_jsx("span", { className: "onboard-form__picture", children: "\u00A0" }), _jsx("h2", { className: "onboard-form__title", children: _jsxs(Trans, { i18nKey: "welcomeToService", values: { siteName: t('siteName') }, children: ["Welcome to ", t('siteName')] }) }), _jsx("p", { className: "onboard-form__text", children: t('emailForImprovement') }), _jsx("p", { className: "onboard-form__text", children: _jsx("input", { ref: (emailRef) => (this.emailRef = emailRef), type: "email", className: clsx('form-control', browser.greaterThan.small && 'form-control-lg'), placeholder: "E-mail", value: email, onChange: this.handleChangeEmail, required: true, autoFocus: true }) }), _jsx("p", { className: "onboard-form__button-container", children: _jsxs("button", { className: clsx('btn btn-primary', browser.greaterThan.small && 'btn-lg'), type: "submit", children: [!this.state.storing ? null : _jsx(Icon, { name: "spinner", spin: true, className: "mr-2", fixedWidth: true }), _jsxs(Trans, { i18nKey: "startUsingService", values: { siteName: t('siteName') }, children: ["Start using ", t('siteName')] })] }) })] }) }));
    }
}
OnboardForm.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    browser: state.browser,
});
/*
const mapDispatchToProps = dispatch => ({
    dispatch: dispatch,
});
*/
export default connect(mapStateToProps /*, mapDispatchToProps*/)(withTranslation()(OnboardForm));
